module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"commonText":"Произошла непредвиденная ошибка, попробуйте повторить попытку позднее или написать на {email}","code":"Код ошибки","proceed":"Продолжить","repeat":"Попробовать еще раз"}}')
  delete Component.options._Ctor
}
